import _ from 'lodash';
import { booting as bootingMusic } from 'containers/MusicPage/actions';
import { setNavData } from 'containers/Menu/actions/menu.actions';
import { getExecute } from 'services/api/microfwk';
import { getNavData } from 'services/api/nav/data';
import isNewExperienceEnabled from 'utils/isNewExperienceEnabled';
import { GetRegion, USER_MODES } from 'constants.js';
import {
  SET_HIGHLIGHT,
  RESPONSE_NAV,
  NODE_SELECTED,
  SET_SECONDMENU_NAVITEMS,
  SET_SECONDMENU_VISIBILITY,
  SET_SECONDMENU_CURRENT_SELECTED,
  SET_SECONDMENU_SUBITEM_SELECTED,
  SET_TEMPORARY_MAIN_SELECTED,
  SET_NAVIGATION_PARAMS,
} from './constants';
import { getNodeByChildCode } from './selectors';
import { getNavType } from '../../utils/getNavType';
import { getRegion } from 'utils/Region';
import { navExperienceService } from 'api/services/nav';
import { setUserTypeLite } from 'action-creators/user';
import { NODOMISCONTENIDOS } from 'utils/redirectMiscontenidos';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { findNodeTarget } from 'utils/findNodeFromChildsNodes';

export const setHighlightsNav = node => dispatch => {
  getExecute(node.url_recommendations)
    .then(data => {
      const { groups } = data.response;
      dispatch(setHighlightNav(groups, node.code));
    })
    .catch(e => {
      console.error('Error in Nav:', e);
    });
};

export const setHighlightNav = (highlights, nodeCode) => ({
  type: SET_HIGHLIGHT,
  highlights,
  nodeCode,
});

export const responseNav = nav => ({ type: RESPONSE_NAV, nav });

export const nodeSelected = nodeCode => ({ type: NODE_SELECTED, nodeCode });

const addIconInfo = (nodes, assets) => {
  return nodes.map(node => {
    const navImage = assets[`ic_imgmenu_${node.code}`] || false;
    const navImageActive = assets[`ic_imgmenu_${node.code}_focused`] || false;
    const navIcon = assets[`ic_menu_${node.code}`] || false;

    return { ...node, navImage, navIcon, navImageActive };
  });
};

export const requestNav = (navigate, redirectCheckOut, refreshNav = false) => (
  dispatch,
  getState,
) => {
  const claroLiteConfig = getClaroAdsKey(getState());
  const isLive =
    getState().Player?.Player?.data?.group?.common?.extendedcommon?.media
      ?.islive === '1' || false;
  const userTypeLite = getState().user?.userTypeLite;
  const promiseFunction = navExperienceService()

  return promiseFunction
    .then(data => {
      const { nodes, nav_type } = data.response;
      const { translations, asset } = getState();
      const pathSplit = window.location.pathname.split('/');
      if (nav_type) dispatch(setUserTypeLite(USER_MODES[nav_type]));
      dispatch(setNavData(addIconInfo(nodes, asset)));
      dispatch(responseNav({ nodes: nodes, nav_type: nav_type }));
      dispatch(nodeSelected(pathSplit[pathSplit.length - 1]));
      sessionStorage.setItem('hasFetchNav', true);


      // redirectCheckOut && redirectCheckOut(nodes);
      let nodeIdSaved = sessionStorage.getItem('nodeIdSaved');
      sessionStorage.removeItem('nodeIdSaved');

      if (nodeIdSaved) {
        const nodeFinded = findNodeTarget(nodes, nodeIdSaved);
        const code = nodeFinded?.code || nodes?.[0]?.code || 'homeuser';
        window.location.replace(`/${getRegion()}/${code}`);
      }

      if (pathSplit[pathSplit.length - 1]?.includes('homeuser')) {
        const isPromogate = window.location.search.includes('isPromoGate');
        if (isPromogate)
          return navigate(`/${getRegion()}/promogate`, { replace: true });
        navigate(`/${getRegion()}/${nodes?.[0]?.code}`, { replace: true });
      }
      nodes?.forEach(node => {
        if (node.url_recommendations) {
          dispatch(setHighlightsNav(node));
        }
      });
      if (
        refreshNav &&
        userTypeLite &&
        userTypeLite !== USER_MODES[nav_type] &&
        !isLive
      ) {
        sessionStorage.setItem('navRedirect', nodes[0]?.code);
        sessionStorage.setItem('navExperienceChanged', true);
      }

      localStorage.setItem(NODOMISCONTENIDOS, JSON.stringify(nodes || []));

      if (isNewExperienceEnabled(translations, GetRegion())) {
        const chooseOne = getNodeByChildCode(
          nodes,
          pathSplit[pathSplit.length - 1],
        );
        if (Object.keys(chooseOne).length > 0) {
          const providerNode = [
            'CRACKLE',
            'FOX',
            'HBO',
            'NOGGIN',
            'INDYCAR',
            'EDYE',
          ].includes(chooseOne.text);
          if (providerNode || chooseOne.layout !== 'playandgo') {
            if (chooseOne.nodes !== null) {
              dispatch(setSecondMenuNavItems(chooseOne.nodes));
            }
            dispatch(
              setSecondMenuSubMenuSelected({ code: chooseOne.selected }),
            );
            if (
              chooseOne.nodes !== null &&
              Object.keys(chooseOne.nodes).length > 0
            ) {
              dispatch(setSecondMenuVisibility(true));
            }
          }
        }
      }
    })
    .catch(e => console.log(e));
};

export const setSecondMenuNavItems = items => {
  let itemsWithoutParent = [];
  if (items) {
    itemsWithoutParent = items.map(item => ({ ...item, parent: null }));
  }
  return { type: SET_SECONDMENU_NAVITEMS, items: itemsWithoutParent };
};

export const setSecondMenuNavItemsDispatch = parameters => dispatch =>
  dispatch(setSecondMenuNavItems(parameters));

export const setSecondMenuVisibility = show => ({
  type: SET_SECONDMENU_VISIBILITY,
  show,
});

export const setSecondMenuVisibilityDispatch = parameters => dispatch =>
  dispatch(setSecondMenuVisibility(parameters));

export const setSecondMenuCurrentSelected = item => ({
  type: SET_SECONDMENU_CURRENT_SELECTED,
  item,
});

export const setSecondMenuCurrentSelectedDispatch = parameters => dispatch =>
  dispatch(setSecondMenuCurrentSelected(parameters));

export const setSecondMenuSubMenuSelected = item => ({
  type: SET_SECONDMENU_SUBITEM_SELECTED,
  item,
});

export const setTemporaryMainSelected = item => ({
  type: SET_TEMPORARY_MAIN_SELECTED,
  item,
});

export const setNavigationParameters = parameters => ({
  type: SET_NAVIGATION_PARAMS,
  parameters,
});

export const setNavigationParamsUgly = parameters => dispatch =>
  dispatch(setNavigationParameters(parameters));

export const setSecondMenuSubMenuSelectedDispatch = parameters => dispatch =>
  dispatch(setSecondMenuSubMenuSelected(parameters));

export const setNodeSelectedDispatch = parameters => dispatch =>
  dispatch(nodeSelected(parameters));
